import { dynamicTranslate, translate } from 'components/Translation';
import { N0_OF_DAYS_FOR_EXPIRY, status } from '../constants';
import moment from 'moment';

export const getCommonData = (
	sevriceStatus: any,
	bwodLabels: any,
	newServiceLength: number = 0,
	existingService?: types.bwod.IService[] | null
) => {
	let activeServicesCount = 0;
	sevriceStatus.forEach((serviceStatus: any) => {
		if (serviceStatus === status.ACTIVE) {
			activeServicesCount++;
		}
	});
	const pendingService = existingService?.find((service) => service.status === status.PENDING);
	const activeService = existingService?.find((service) => service.status === status.ACTIVE);
	if (sevriceStatus.includes(status.ACTIVE)) {
		if (sevriceStatus.includes(status.EXPIRED)) {
			//active and expired card
			return {
				buttonText: '', // if button text is empty then button is not rendered, and button is not needed for this combination
				heading: bwodLabels.activeHeading,
				status: status.ACTIVE,
			};
		} else if (sevriceStatus.includes(status.PENDING)) {
			//active and pending card
			return {
				buttonText: bwodLabels.extendNow,
				heading: bwodLabels.activeHeading,
				status: status.ACTIVE,
				disableButton: true,
			};
		} else if (activeServicesCount === 1 && activeService?.actualDurationMonths == '1' && newServiceLength > 0) {
			//active and active card
			return {
				buttonText: bwodLabels.extendNow,
				heading: bwodLabels.extendForNextMonth,
				footerHeading: bwodLabels.extendAfterOneMonth,
				status: status.ACTIVE,
				disableButton: true,
				hideButton: newServiceLength === 0,
				newPlanAvailable: false,
			};
		} else if (activeServicesCount > 0) {
			//active and active card
			return {
				buttonText: bwodLabels.extendNow,
				heading: bwodLabels.activeHeading,
				status: status.ACTIVE,
				disableButton: true,
				hideButton: newServiceLength === 0,
				newPlanAvailable: false,
			};
		}
	} else if (sevriceStatus.includes(status.PENDING)) {
		if (!sevriceStatus.includes(status.ACTIVE)) {
			//pending and active card
			return {
				buttonText: bwodLabels.extendNow,
				heading: dynamicTranslate(bwodLabels.pendingHeading, pendingService?.orderId || ''),
				status: status.PENDING,
				disableButton: true,
			};
		} else if (sevriceStatus.includes(status.EXPIRED)) {
			//pending and expired card
			return {
				buttonText: bwodLabels.extendNow,
				heading: bwodLabels.expiredHeading,
				status: status.EXPIRED,
				disableButton: true,
			};
		}
	} else if (sevriceStatus.includes(status.EXPIRED)) {
		if (!(sevriceStatus.includes(status.ACTIVE) && sevriceStatus.includes(status.PENDING))) {
			//one card is expired and other is neither active nor pending then we show extend now button
			return {
				buttonText: bwodLabels.extendNow,
				heading: bwodLabels.expiredHeading,
				status: status.EXPIRED,
				disableButton: false,
				newPlanAvailable: true,
			};
		}
		//one card is expired and other is either active nor pending then we show extend now disabled button and expired card
		return {
			buttonText: bwodLabels.extendNow,
			heading: bwodLabels.expiredHeading,
			status: status.EXPIRED,
			disableButton: true,
		};
	}
};

/** This methid is used to extract plan details like duration, expiry, cost etc. But there are different details needed for activ, pending and expired statuses */
export const extractplanDetails = (allPlansDetails: any, bwodLabels: any, commonLabels: any) => {
	const detailsArray: any = [];
	allPlansDetails.forEach((plan: any) => {
		//This key is used to extract Month or Months translation based on the actualDurationMonths
		const monthKey = plan.actualDurationMonths == 1 ? bwodLabels.month : bwodLabels.months;
		const activationCost = [
			{
				key: bwodLabels.addOnCostHeading,
				value: dynamicTranslate(
					bwodLabels.extraVat,
					parseInt(plan.activationCost) * parseInt(plan.actualDurationMonths),
					plan.vat
				),
			},
		];
		//activation cost details is common for all types of card here in the body array.
		let body = [...activationCost];

		const availableFor = [
			{
				key: bwodLabels.addOnAvailable,
				value: dynamicTranslate(monthKey, plan.actualDurationMonths),
			},
		];
		const duration = [
			{
				key: bwodLabels.addOnDureation,
				value: dynamicTranslate(monthKey, plan.actualDurationMonths),
			},
		];
		const expiration = [
			{
				key: bwodLabels.addOnExpires,
				value: moment(plan.endDate).format('Do MMMM YYYY'),
			},
		];
		const requestedOn = [
			{
				key: bwodLabels.addOnRequested,
				value: moment(plan.requestedDate).format('Do MMMM YYYY'),
			},
		];
		switch (plan.status) {
			case status.ACTIVE:
				body = [...body, ...duration, ...expiration]; //active card needs to show only cost, duation and expiration, hence pushing body with these details
				break;
			case status.PENDING:
				body = [...body, ...duration, ...requestedOn]; //pending card needs to show only cost, duration and requestedOn, hence pushing body with these details
				break;
			case status.EXPIRED:
				body = [...body, ...availableFor]; //expired card needs to show only cost and availableFor, hence pushing body with these details
		}

		/** The details object has plan name, plan details inside body, plan status as active/pending or expired and tooltip information */
		const details = {
			planName: `${plan.productName}  ${plan.downloadSpeed}`,
			body: [...body],
			status: plan.status,
			tooltip: [
				{
					key: bwodLabels.speedUpPrice,
					value: dynamicTranslate(bwodLabels.speedUpPriceValue, plan.activationCost, plan.vat),
				},
				{ key: bwodLabels.validity, value: bwodLabels.twoMonthValidity },
			],
		};
		detailsArray.push(details);
	});

	return detailsArray;
};

export const sortingOrder = {
	[status.ACTIVE]: 1,
	[status.PENDING]: 2,
	[status.EXPIRED]: 3,
};

/* This method id used to calculate if teh expiry is 5 days from now so that we show appropriate banner*/
export const daysLeftForExpiry = (expiryDate: string) => {
	const givenDate = expiryDate;
	const currentDate = moment();
	const modifiedGivenDate = moment(givenDate, 'YYYY-MM-DD');
	const daysDifference = modifiedGivenDate.diff(currentDate, 'days');
	return daysDifference;
};
